import { FilterOperator } from './Enums.enum';

export interface FilterOperatorModel {
  code: string;
  label: string;
  operator: FilterOperator;
  additionalInfo?: string;
}
//#region Common filter operators
const isEqual: FilterOperatorModel = {
  code: 'isEqual',
  label: 'Is Equal To',
  operator: FilterOperator.isEqual,
};
const inList: FilterOperatorModel = {
  code: 'inList',
  label: 'in List',
  operator: FilterOperator.inList,
};
const isEmpty: FilterOperatorModel = {
  code: 'isEmpty',
  label: 'Is Empty',
  operator: FilterOperator.isEmpty,
  additionalInfo: '{"needValue":false}',
};
const isNotEmpty: FilterOperatorModel = {
  code: 'isNotEmpty',
  label: 'Is Not Empty',
  operator: FilterOperator.isNotEmpty,
  additionalInfo: '{"needValue":false}',
};
const lessThan: FilterOperatorModel = {
  code: 'lessThan',
  label: 'Less Than',
  operator: FilterOperator.lessThan,
};
const greaterThan: FilterOperatorModel = {
  code: 'greaterThan',
  label: 'Greater Than',
  operator: FilterOperator.greaterThan,
};
const lessOrEqual: FilterOperatorModel = {
  code: 'lessOrEqual',
  label: 'Less Or Equals',
  operator: FilterOperator.lessOrEqual,
};
const greaterOrEqual: FilterOperatorModel = {
  code: 'greaterOrEqual',
  label: 'Greater Or Equals',
  operator: FilterOperator.greaterOrEqual,
};
const between: FilterOperatorModel = {
  code: 'between',
  label: 'Between',
  operator: FilterOperator.between,
};
const notBetween: FilterOperatorModel = {
  code: 'notBetween',
  label: 'Not Between',
  operator: FilterOperator.notBetween,
};
//#endregion

export const FilterOperators: { [key: string]: FilterOperatorModel[] } = {
  String: [
    isEqual,
    {
      code: 'contains',
      label: 'Contains',
      operator: FilterOperator.contains,
    },
    {
      code: 'doesntContain',
      label: "Doesn't Contain",
      operator: FilterOperator.doesntContain,
    },
    {
      code: 'startsWith',
      label: 'Starts With',
      operator: FilterOperator.startsWith,
    },
    // inList,
    isEmpty,
    isNotEmpty,
  ],
  Number: [
    isEqual,
    lessOrEqual,
    lessThan,
    greaterOrEqual,
    greaterThan,
    between,
    notBetween,
    isEmpty,
    isNotEmpty,
  ],
  Date: [
    isEqual,
    lessOrEqual,
    lessThan,
    greaterOrEqual,
    greaterThan,
    between,
    notBetween,
    isEmpty,
    isNotEmpty,
  ],
  Select: [isEqual, isEmpty, isNotEmpty],
  Boolean: [isEqual, isEmpty, isNotEmpty],
};
